export default __webpack_public_path__ + "static/media/undo-01 1.a9e433cf.svg";